<template>
  <div class="text-sm-left">
    <span v-if="debug === 'true' || debug === true">{{ version }}</span>

    <b-row class="mt-4">
      <b-col sm="12" md="6" lg="4" xl="4">
        <label for="Apellido paterno"> Apellido Paterno: </label>
        <b-form-input
          v-model="persona.apellidoPaterno"
          placeholder="Apellido paterno:"
          disabled
        >
        </b-form-input>
      </b-col>
      <b-col sm="12" md="6" lg="4" xl="4">
        <label for="Apellido materno"> Apellido materno: </label>
        <b-form-input
          v-model="persona.apellidoMaterno"
          placeholder="Apellido materno:"
          disabled
        >
        </b-form-input>
      </b-col>
      <b-col sm="12" md="6" lg="4" xl="4">
        <label for="Nombre(s)"> Nombre(s): </label>
        <b-form-input
          v-model="persona.nombre"
          placeholder="Nombre(s):"
          disabled
        >
        </b-form-input>
      </b-col>
    </b-row>

    <b-row class="mt-4">
      <b-col sm="9" md="4" lg="3" xl="3">
        <label for="sobrenombre"> Sobrenombre: *</label>
        <b-form-input
          v-model="persona.sobreNombre"
          placeholder="¿Como te gusta que te llamen?"
          :state="persona.sobreNombre != '' && persona.sobreNombre != null"
          required
          v-on:keypress="esLetra($event)"
        ></b-form-input>
        <b-form-invalid-feedback
          :state="persona.sobreNombre != '' && persona.sobreNombre != null"
        >
          Se debe colocar un sobrenombre.
        </b-form-invalid-feedback>
      </b-col>

      <b-col sm="9" md="4" lg="3" xl="3">
        <label for="Fecha nacimiento"> Fecha de nacimiento: </label>
        <b-form-input
          v-model="persona.fechaNacimiento"
          placeholder="Fecha nacimiento:"
          disabled
        ></b-form-input>
      </b-col>

      <b-col sm="9" md="4" lg="3" xl="3">
        <label for="edad"> Edad: </label>
        <b-form-input v-model="persona.edad" placeholder="Edad:" disabled>
        </b-form-input>
      </b-col>

      <b-col sm="9" md="4" lg="3" xl="3">
        <label for="sexo"> Género: </label>
        <v-select
          style="width: 100%"
          label="nombre"
          id="sexoComp"
          :options="listaSexo"
          :reduce="(val) => val.nombre"
          v-model="persona.sexo"
          placeholder="Selecciona un sexo"
        ></v-select>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "DatosPacienteHC",
  props: {
    persona: Object,
    listaEnterarse: Array,
    listaSexo: Array,
    cargandoPlanes: Boolean,
    cargandoCercania: Boolean,
    cargandoConfianza: Boolean,
    cargandoMedio: Boolean,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    nombrePlan: "",
    idPlan: null,
  }),
  methods: {
    esLetra(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[A-Za-zÁÉÍÓÚáéíóúñÑ\s]+$/.test(char)) return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
};
</script>

<style scoped>
label{
  color: #0046A2 !important;
}
</style>
